// views/index.js
const CatalogoView = () => import('./catalogo/CatalogoView.vue');
const CatalogoConfigView = () => import('./catalogo/config/ConfigView.vue');
const WelcomeView = () => import('./home/WelcomeView.vue');
const LoginView = () => import('./auth/LoginView.vue');
const PedidoView = () => import('./pedido/PedidoView.vue');
const PedidoListView = () => import('./pedido/PedidoListView.vue');
const NotFoundView = () => import('./error/NotFoundView.vue');
const EmailBookView = () => import('./emailbook/EmailBookView.vue');
const BrandEmailBookView = () => import('./emailbook/marcas/BrandEmailBookView.vue');
const UserEmailBookView = () => import('./emailbook/usuarios/UserEmailBookView.vue');
const ProfileView = () => import('./profile/ProfileView.vue');
const UserInfoView = () => import('./profile/UserInfo/UserInfoView.vue');
const TransitoLabListView = () => import('./transito/TransitoLabListView.vue');
const TransitoLabFormView = () => import('./transito/TransitoLabFormView.vue');
const PermisosView = () => import('./permisos/PermisosView.vue');
const PedidoPlantillasView = () => import('./pedido/PedidoPlantillasView.vue');

export default {
    CatalogoView,
    CatalogoConfigView,
    WelcomeView,
    LoginView,
    PedidoView,
    PedidoListView,
    NotFoundView,
    EmailBookView,
    BrandEmailBookView,
    UserEmailBookView,
    ProfileView,
    UserInfoView,
    TransitoLabListView,
    TransitoLabFormView,
    PermisosView,
    PedidoPlantillasView,
};